// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"ProductList_contentContainer__6mi3O"};